let deprecate = () => Wrapped => {
  return Wrapped
}

if (process.env.NODE_ENV) {
  deprecate = ({ message, name }) => Wrapped => {
    const componentName = name || Wrapped.displayName || 'this'
    const warningMessage = `Warning: Using deprecated component ${componentName}. ${message || 'This will be removed in the next major version.'}`
    console.warn(warningMessage)
    try {
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(warningMessage)
    } catch (x) {}
    return Wrapped
  }
}

export default deprecate
